import { render, staticRenderFns } from "./tabellaDistinta.vue?vue&type=template&id=2ae433c9&scoped=true"
import script from "./tabellaDistinta.vue?vue&type=script&lang=js"
export * from "./tabellaDistinta.vue?vue&type=script&lang=js"
import style0 from "./tabellaDistinta.vue?vue&type=style&index=0&id=2ae433c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae433c9",
  null
  
)

export default component.exports